import { title } from "process"

export class Image {
    title: string;
    url: string;
    format: string;
}